import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';
// import { environment } from '../../../../environments/environment';

import { API } from 'aws-amplify';
import { Observable } from 'rxjs';
import { ConfigService } from '../../config';

@Injectable({
  providedIn: 'root'
})
export class AlertHttpService {

    apiName: string;

    constructor(private http: HttpClient, private configService: ConfigService) {
        this.apiName = this.configService.get('host');
    }

	initMachine(formObj): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/init_machine';
			const params = {
				body: formObj
			};
			API.post(this.apiName, path, params).then(resp => {
				observer.next(resp);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getIssueReason(): Observable<any> {
        return new Observable((observer: any) => {
            const path = '/dashboard/oiclearreasons';
            const params = {
                response: false
            };
            API.get(this.apiName, path, params).then(response => {
                observer.next(response.data);
            }).catch(err => {
                console.log(err.response);
                observer.error(err);
            });
        });
	}

	clearOI(obj: any): Observable<any> {
        return new Observable((observer: any) => {
            const path = '/dashboard/clearoi';
            const params = {
                body: obj
            };
            API.post(this.apiName, path, params).then(response => {
                observer.next(response);
            }).catch(err => {
                console.log(err.response);
                observer.error(err);
            });
        });
    }


	getOpenIssues(m_id: string): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get_open_issues/' + m_id;
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getMachineLogs(queryParams: any): Observable<any> {
		return new Observable((observer: any) => {
			let path;
			if (queryParams.optFilterVal === 'evt') {
				path = '/dashboard/get_events';
			} else {
				path = '/dashboard/get_logs';
			}
			const myInit = {
				response: false,
				queryStringParameters: queryParams
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getMacLogCodes(): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get_log_code_dict';
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(log_codes => {
				const payLoad: any = {};
				const result = [];
				for (const code of log_codes.data) {
					if (!result[code.occOrRes]) {
						result[code.occOrRes] = {[code.log_code] : code.log_msg};
					} else {
						result[code.occOrRes][code.log_code] = code.log_msg;
					}
				}
				console.log(result);

				payLoad.processed = result;
				payLoad.raw = log_codes.data;
				observer.next(payLoad);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

}
